import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import EagleBackdrop from "./EagleBackdrop";

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`relative mx-auto w-full max-w-7xl px-6 md:px-10 ${className}`}>
    {children}
  </section>
);

export const Eyebrow = ({ children }) => (
  <span className="eyebrow" data-testid="section-eyebrow">
    {children}
  </span>
);

// Standardized hero header used across inner pages.
export const PageHero = ({ eyebrow, title, highlight, description, children, eagle = false }) => (
  <header className="relative overflow-hidden pt-40 pb-20 md:pt-48 md:pb-28">
    {eagle ? (
      <EagleBackdrop position="top" />
    ) : (
      <>
        <div className="pointer-events-none absolute inset-0 radial-fade" />
        <div className="pointer-events-none absolute inset-0 grid-lines opacity-40" />
      </>
    )}
    <div className="relative mx-auto w-full max-w-5xl px-6 text-center md:px-10">
      <Reveal>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <h1 className="mt-5 font-heading text-4xl font-medium leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title} {highlight && <span className="text-gold-gradient">{highlight}</span>}
        </h1>
        {description && (
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
            {description}
          </p>
        )}
        {children && <div className="mt-9 flex flex-wrap items-center justify-center gap-4">{children}</div>}
      </Reveal>
    </div>
  </header>
);

export const FeatureCard = ({ icon: Icon, title, desc, to, testid }) => {
  const inner = (
    <div
      data-testid={testid}
      className="group h-full rounded-2xl border border-white/10 bg-[#0a0a0a] p-7 transition-colors duration-300 hover:border-gold/30"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] text-gold transition-colors duration-300 group-hover:border-gold/40">
        {Icon && <Icon className="h-5 w-5" strokeWidth={1.6} />}
      </div>
      <h3 className="mt-6 font-heading text-xl font-medium text-white">{title}</h3>
      <p className="mt-3 text-sm leading-relaxed text-zinc-400">{desc}</p>
      {to && (
        <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-gold opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          Explore →
        </span>
      )}
    </div>
  );
  return to ? (
    <Link to={to} className="block h-full">
      {inner}
    </Link>
  ) : (
    inner
  );
};
